import Input from "./Input";

export default class InputSelect extends Input {
    constructor({ container, input, label, error }) {
        super({ container, input, label, error });
    }
}